import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Mexican() {
  return (
    <ApiCommunityDirectoryPage
      community="Mexican"
      eyebrow="Mexican community guide"
      title="Mexican favorites, businesses, and local essentials in San Antonio."
      
      tags={["Mexican community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Mexican community guide?"
      modalIdPrefix="mexican-directory"
    />
  );
}
